export default {
  sendOtp: "applications/sendOTP",
  resendOtp: "applications/resendOtp",
  verifyOtp: "applications/verifyOTP",
};
